module.exports = __webpack_public_path__ + "img/cog.b0c16a3a.svg";